module.exports = __webpack_public_path__ + "static/media/Arrow.ed61b0fd.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/Arrow.gif
 ** module id = 81
 ** module chunks = 0
 **/